import fetchPriceRequest from 'app/apis/fetchPriceRequest'
import ToastAndroid from 'app/mocks/ToastAndroid'
import { PriceChangeRequest } from 'app/models/RequestFlow'
import { fixNextPageUrl } from 'app/utils/helpers/fixNextPageUrl'
import { useCallback, useEffect, useState } from 'react'

const useChangePrice = ({
  request_type,
  status,
  lang = 'en',
  roleType,
  created_at_after,
  created_at_before,
  enabled
}: {
  request_type?: string
  status?: string
  lang?: string
  roleType?: string
  created_at_after?: string
  created_at_before?: string
  enabled?: boolean
}) => {
  const [request, setRequest] = useState<PriceChangeRequest[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingNext, setLoadingNext] = useState(false)
  const [page, setPage] = useState(1)
  const [nextPageUrl, setNextPageUrl] = useState<string | null>('')

  const fetchNext = useCallback(async () => {
     if (!enabled || !roleType || !nextPageUrl) return
      try {
        setLoadingNext(true)
        const response = await fetchPriceRequest(
          page + 1,
          request_type,
          status,
          roleType,
          created_at_after,
          created_at_before,
        )
        if (response) {
          setRequest(prev => prev.concat(response.results))
          setPage(prev => prev + 1)
          setNextPageUrl(fixNextPageUrl(response.next) || null)
        }
      } catch (e) {
        ToastAndroid.show('Something went wrong', ToastAndroid.SHORT)
      } finally {
        setLoadingNext(false)
      }
  }, [
    enabled,
    nextPageUrl,
    page,
    request_type,
    status,
    roleType,
    created_at_after,
    created_at_before,
  ])

  const getRequest = useCallback(async () => {
    if (!enabled || !roleType) {
      return
    }
    setLoading(true)
    try {
      const response = await fetchPriceRequest(
        1,
        request_type,
        status,
        roleType,
        created_at_after,
        created_at_before,
      )
      if (response) {
        setRequest(response.results)
        setNextPageUrl(fixNextPageUrl(response.next) || null)
        setPage(1)
      }
    } catch (e) {
      ToastAndroid.show('Something went wrong', ToastAndroid.SHORT)
    } finally {
      setLoading(false)
    }
  }, [request_type, status, roleType, created_at_after, created_at_before,enabled])

  useEffect(() => {
  if (enabled) {
    getRequest()
  }
}, [enabled, getRequest, roleType])

  return {
    enabled,
    fetchNext,
    request,
    loading,
    loadingNext,
    getRequest,
  }
}

export default useChangePrice
